import request from '@/utils/request'


export const getUserInfo = () => {
  return request({
    url: '/waic/account/user/info/get',
  })
}

export const userLogout = () => {
  return request({
    url: '/waic/account/console/logout',
  })
}

export const startRecordSession = (data: any) => {
  return request({
    url: '/waic/core/web/sessions',
    data,
    intercept: false,
  })
}
export const uploadRecordChunk = (data: any) => {
  return request({
    url: '/waic/core/web/events',
    data,
    intercept: false,
  })
}

